import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { api } from "@/lib/api";
import { useI18n } from "@/lib/i18n";

const T = {
  it: { over: "Journal", title: "Notizie, nutrizione e benessere.", sub: "Contenuti informativi su nutrizione, benessere e cura quotidiana. Ogni articolo ha finalità informative e non sostituisce il parere del medico o del veterinario.", all: "Tutti", empty: "Nessun articolo pubblicato al momento." },
  en: { over: "Journal", title: "News, nutrition and wellbeing.", sub: "Informational content on nutrition, wellbeing and daily care. Every article is informational and does not replace medical or veterinary advice.", all: "All", empty: "No articles published yet." },
};

export default function JournalPage() {
  const { t, lang } = useI18n();
  const c = T[lang];
  const [articles, setArticles] = useState([]);
  const [category, setCategory] = useState("");

  useEffect(() => {
    api.get("/articles", { params: category ? { category } : {} }).then((r) => setArticles(r.data || []));
  }, [category]);

  const categories = Array.from(new Set(articles.map((a) => a.category).filter(Boolean)));

  return (
    <div className="mx-auto max-w-[1400px] px-6 lg:px-10 py-16 lg:py-20" data-testid="journal-page">
      <div className="mb-12 max-w-3xl">
        <div className="text-xs uppercase tracking-editorial text-muted-ink mb-3">{c.over}</div>
        <h1 className="font-display text-5xl md:text-6xl text-brand leading-tight">{c.title}</h1>
        <p className="mt-4 text-muted-ink">{c.sub}</p>
      </div>

      {categories.length > 0 && (
        <div className="mb-10 flex flex-wrap gap-2">
          <button
            className={`px-4 py-2 text-xs uppercase tracking-editorial border ${
              !category ? "bg-brand text-white border-brand" : "border-soft text-brand hover:bg-cream-warm"
            }`}
            onClick={() => setCategory("")}
          >
            {c.all}
          </button>
          {categories.map((cat) => (
            <button
              key={cat}
              className={`px-4 py-2 text-xs uppercase tracking-editorial border ${
                category === cat ? "bg-brand text-white border-brand" : "border-soft text-brand hover:bg-cream-warm"
              }`}
              onClick={() => setCategory(cat)}
            >
              {cat}
            </button>
          ))}
        </div>
      )}

      {articles.length === 0 ? (
        <div className="border border-dashed border-soft p-16 text-center text-muted-ink">
          {c.empty}
        </div>
      ) : (
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {articles.map((a) => (
            <Link
              key={a.slug}
              to={`/journal/${a.slug}`}
              className="group flex flex-col"
              data-testid={`article-card-${a.slug}`}
            >
              <div className="image-hover-scale aspect-[4/3] overflow-hidden bg-cream-warm mb-4">
                <img src={a.image} alt={a.title} loading="lazy" className="w-full h-full object-cover" />
              </div>
              <div className="text-[10px] uppercase tracking-editorial text-muted-ink mb-2">
                {a.category} · {a.read_time} min
              </div>
              <h3 className="font-display text-2xl text-brand leading-tight">{a.title}</h3>
              <p className="mt-2 text-sm text-muted-ink">{a.excerpt}</p>
              <div className="mt-3 inline-flex items-center gap-1 text-sm text-brand link-underline w-fit">
                {t("common.read_more")} <ArrowUpRight className="h-3 w-3" />
              </div>
            </Link>
          ))}
        </div>
      )}
    </div>
  );
}
